export default __webpack_public_path__ + "static/media/Brewers.34e05fb1.png";